import useUser from '../hooks/use-user'
import { can } from '../services/user-utils'
import NotFound from './errors/components/not-found'
import { useWellState } from '../context/well-context'
import { Heading, PageSkeleton } from '@msaf/core-react'

export function RoutePermissionCheck({
  isPublic,
  permissions,
  children,
}: React.PropsWithChildren<{ isPublic?: boolean; permissions?: Array<string> }>) {
  // Let everyone access the public route
  const { user, isLoading } = useUser()

  // The user is still loading, we can't do permissions checks yet
  if (isLoading) return <PageSkeleton />

  // This is a public page so no further checks needed
  if (isPublic) return <>{children}</>

  // Its not loading and we don't have a user. This shouldn't be possible.
  if (!user) return <Heading level={1}>Error</Heading>

  // If the route is not public, and has no permissions, let any authenticated user access
  if (!permissions) return <>{children}</>

  // has a user and a list of permissions but the user doesn't have the permission
  if (!can(user, permissions)) return <NotFound />

  return <>{children}</>
}

export function WellRoutePublicPublishedPermissionsCheck({
  children,
  permissions,
}: React.PropsWithChildren<{ permissions: Array<string> }>): JSX.Element {
  const { wellState } = useWellState()
  return (
    <RoutePermissionCheck permissions={permissions} isPublic={wellState?.isPublished}>
      {children}
    </RoutePermissionCheck>
  )
}
